/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export function getNormalizedTypeId(typeId: string): string {
    const mapping: Record<string, string> = {
        'commerce_assets.hero': 'Content.hero',
        'commerce_assets.productTile': 'Content.productTile',
        'commerce_assets.popularCategories': 'Layout.popularCategories',
        'commerce_assets.popularCategory': 'Content.popularCategory',
        'commerce_assets.productCarousel': 'Layout.productCarousel',
        'commerce_assets.heroCarousel': 'Layout.heroCarousel',
        'commerce_assets.grid': 'Layout.grid',
        'commerce_assets.pdImage': 'Content.pdImage',
        'commerce_assets.contentCard': 'Content.contentCard',
        'commerce_assets.productRecommendations': 'Content.productRecommendations',
        'commerce_assets.singleTile': 'Content.contentCard',
        'assets.categorytile': 'Content.popularCategory',
        'commerce_assets.categorytile': 'Content.popularCategory',
    };

    return mapping[typeId] || typeId;
}

export function normalizeComponentData(typeId: string, data: any): any {
    const normalizedData = data ? { ...data } : {};

    if (typeId === 'commerce_assets.singleTile') {
        normalizedData.imageUrl = normalizedData.DifferenceImage;
        normalizedData.description = normalizedData.descriptionTitle;
    }

    return normalizedData;
}
